import { BundleModifyTypes, PurchaseTypes } from "../app/shared/types/flows-config.types";
import { BundleEditionTypes } from "../app/shared/types/order.type";

const base_api = "https://willowhaven-back-dev.navego.tech/";

export const environment = {
  production: false,
  apis: {
    v1: `${base_api}`,
    v2: `${base_api}/api/v2`,
    v3: `${base_api}/api/v3`,
    google: {
      places: 'AIzaSyBTHTviZ7QPtEjH29Jmmkp13RO8LPrxppM'
    },
    firebase: {
      apiKey: "AIzaSyCiE-ail75SmFuNykik5_CbfX5URNMVAlQ",
      authDomain: "dev-willow-heaven.firebaseapp.com",
      projectId: "dev-willow-heaven",
      storageBucket: "dev-willow-heaven.firebasestorage.app",
      messagingSenderId: "116989950926",
      appId: "1:116989950926:web:3aac54a988481cb4d5499f",
      measurementId: "G-99ST7TQ9RC"
    },
    fireauth: {
      email: 'javier.franco@eliostudios.co',
      password: '@N4v3g0.T3ch.2024**'
    },
    klaviyo: {
      publicApiKey: 'Ufqp3c'
    },
    maintenance: {
      url: 'https://ecommerce-configurations.navego.tech/api/v3/maintenance?url=willowheaven-testing.com'
    },
    authorize: {
      APILoginID: '859vpT8YqF',
      PublicClientkey: '2789LLpawLnj4TJe2s5k7akamxnXS3aTq442sEs4vkU82JnTQ56e93fNuMUXmfC6'
    }
  },
  application: {
    angular: 'Angular 17.3.7',
    bootstrap: 'Bootstrap 5.3.2',
    fontawesome: 'Font Awesome 6.5.1',
    name: 'Willow Haven',
    version: '1.0.0',
  },
  config: {
    bodyClass: 'app-me',
    flows: {
      territories: false,
      membership: true,
      settings: {
        toHide: {
          membership: 'Membership'
        },
        profile: {
          hasPickupLocationsFlow: true
        },
        deliveryDayUpdates: {
          displayOnlyActiveReescheduledOrder: true
        }
      },
      specialMembership: {
        defaultRoute: '/order/custom-box/' + BundleEditionTypes.subscription,
        settings: {
          hideHeaderCategoriesNav: true
        },
      },
      order: {
        askForDonationOnSkip: true,
        showFreeDeliverySlider: true,
        voluntaryDonationFlow: true,
        showProductStatusTag: false,
        hasDriveTipsFlow: true,
      },
      bundles: {
        modifyType: BundleModifyTypes.outOfOrder
      },
      shop: {
        validateMarketState: true,
        displayCategoryName: false
      },
      login: {
        tempResetPassword: true
      },
      purchase: {
        type: PurchaseTypes.nmi
      }
    },
    filesVersionNumber: {
      logo: 2
    },
    friendReferral: {
      baseUrl: 'https://willowhaven-front-dev.navego.tech/signup?utm_source=friend_referral&utm_medium=share&utm_campaign='
    },
    seo: {
      mainTitle: 'Willow Haven Farm - Organic Farm Food | New Tripoli PA',
      mainDescription: 'Want to improve your family’s health and nutrition this summer? At Willow Haven Farm, we provide the healthiest organic farm food! Visit us!',
      baseTitle: 'Willow Haven Farm - Organic Farm Food | New Tripoli PA',
      baseKeywords: ['Sustainable', 'Local', 'Regional', 'Home Delivery', 'Fresh Produce', 'Online Ordering', 'Willow Haven Farm', 'Food'],
      type: 'website',
      baseURL: 'https://willowhavenfarmpa.com/',
      allowedHosts: ['localhost', 'willowhaven-front-dev.navego.tech', '*.willowhaven-front-dev.navego.tech'],
    },
    contactEmail: 'farmer@willowhavenfarmpa.com'
  },
};
